import { Box, CloseButton, Drawer, Portal } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { AdaptiveDrawerProps } from './adaptive-drawer.props';

export const AdaptiveDrawer = ({
    isOpen,
    onOpen,
    onClose,
    header,
    onCloseComplete,
    footer,
    contentProps,
    drawerProps,
    children,
    bodyRef,
    ...bodyProps
}: AdaptiveDrawerProps) => {
    return (
        <Drawer.Root
            modal={false}
            lazyMount={true}
            unmountOnExit={true}
            open={isOpen}
            onOpenChange={details => {
                setTimeout(() => (details.open ? onOpen?.() : onClose()), 0);
            }}
            onExitComplete={onCloseComplete}
            size={'lg'}
            placement={'end'}
            {...drawerProps}
        >
            <Portal>
                <Drawer.Backdrop />
                <Drawer.Positioner>
                    <Drawer.Content {...contentProps}>
                        <Drawer.Header
                            borderBottomWidth={'1px'}
                            fontWeight={'normal'}
                            fontSize={'md'}
                            pl={12}
                            minH={header ? undefined : '3em'}
                            zIndex={'sticky'}
                            top={0}
                            bg={'var(--bg-currentcolor)'}
                            data-testid={'drawer-header'}
                        >
                            <Drawer.CloseTrigger
                                right={'auto'}
                                left={0.5}
                                top={0.5}
                                data-testid={'drawer-close'}
                                asChild
                            >
                                <CloseButton>
                                    <IconsLinear.ArrowLeft />
                                </CloseButton>
                            </Drawer.CloseTrigger>

                            <Box as={'span'} data-testid={'drawer-heading'}>
                                {header ? header : null}
                            </Box>
                        </Drawer.Header>
                        <Drawer.Body data-testid={'drawer-body'} {...bodyProps} ref={bodyRef}>
                            {children}
                        </Drawer.Body>
                        {footer ?? null}
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    );
};
